module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dynamic-product-simple",
    on: {
      "click": _vm.jump
    }
  }, [(_vm.productImage) ? _c('div', {
    staticClass: "product-image",
    style: ({
      'height': (_vm.productImageHeight + "px")
    })
  }, [_c('beast-image', {
    attrs: {
      "lazy": true,
      "defaultImage": _vm.defaultImage,
      "src": _vm.productImage
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "image-state",
    style: ({
      'height': (_vm.productImageHeight + "px"),
      'top': ((-_vm.productImageHeight) + "px")
    })
  }, [(_vm.data.foretell) ? _c('div', {
    staticClass: "corner-box"
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), (_vm.data.offShelf) ? _c('div', {
    staticClass: "corner-box"
  }, [_vm._m(1)]) : (_vm.data.soldOut) ? _c('div', {
    staticClass: "corner-box"
  }, [_vm._m(2)]) : _vm._e()])], 1) : _c('div', {
    staticClass: "product-image"
  }, [_c('img', {
    attrs: {
      "src": _vm.defaultImage
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "product-infos",
    class: {
      'hide-pad': _vm.hideInfoPadding
    }
  }, [(_vm.data.activityDesc) ? _c('div', {
    staticClass: "summary"
  }, [_vm._v(_vm._s(_vm.data.activityDesc))]) : _vm._e(), _vm._v(" "), (_vm.data.customizable) ? _c('div', {
    staticClass: "tag"
  }, [_vm._v("定制")]) : (_vm.data.isOversea) ? _c('div', {
    staticClass: "tag"
  }, [_vm._v("跨境商品")]) : _vm._e(), _vm._v(" "), (_vm.productCondition.brandName === 'SHOW' && _vm.data.brand) ? _c('div', {
    staticClass: "brand-name gro-book"
  }, [_vm._v(_vm._s(_vm.data.brand && _vm.data.brand.name))]) : _vm._e(), _vm._v(" "), (_vm.productCondition.productName !== 'HIDE') ? _c('div', {
    staticClass: "name",
    class: {
      'one': _vm.productCondition.productName === 'ONE', 'two': _vm.productCondition.productName === 'TWO'
    }
  }, [_vm._v(_vm._s(_vm.data.name))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "price-box"
  }, [(_vm.productCondition.rawPrice !== 'HIDE' || _vm.productCondition.nowPrice !== 'HIDE') ? _c('div', {
    staticClass: "prices",
    class: {
      'newn': _vm.data.newcomerTag
    }
  }, [(_vm.productCondition.nowPrice !== 'HIDE') ? _c('div', {
    staticClass: "price discount-price gro-demi"
  }, [(_vm.data.price) ? _c('price', {
    attrs: {
      "data": _vm.data.price
    }
  }) : _vm._e(), _c('span', {
    staticClass: "newn-tag"
  }, [_vm._v("新人价")])], 1) : _vm._e(), _vm._v(" "), (_vm.productCondition.rawPrice !== 'HIDE' && _vm.data.price < _vm.data.rawPrice) ? _c('del', {
    staticClass: "price raw-price grotesk"
  }, [(_vm.data.rawPrice) ? _c('price', {
    attrs: {
      "data": _vm.data.rawPrice
    }
  }) : _vm._e()], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.data.stockWarn) ? _c('div', {
    staticClass: "stock-warn"
  }, [_vm._v(_vm._s(_vm.data.stockWarn || ''))]) : _vm._e()]), _vm._v(" "), (_vm.data.refunds) ? _c('div', {
    staticClass: "refund-box"
  }, [_c('div', {
    staticClass: "refund"
  }, [_vm._v("约返" + _vm._s(_vm._f("formatPrice")(_vm.data.refunds)) + "元")])]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "stats-tag"
  }, [_c('span', [_vm._v("即将开售")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "stats-tag"
  }, [_c('span', [_vm._v("下架")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "stats-tag"
  }, [_c('span', [_vm._v("售罄")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-23404ff3"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./static/components/dynamic-product-simple/index.vue
// module id = 654
// module chunks = 1 13